// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 177 ? "home" : chunkId) + "." + {"177":"4bceb94f","403":"26ce3055","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};